<template>
  <div class="col">
    <div class="musteriler-karsilama card mb-4 border-0 shadow-sm">
      <div class="card-body py-4">
        <h2 class="h4 mb-1">{{ karsilamaMesaji }}</h2>
        <p class="text-muted mb-0">
          {{ filteredmusteriler.length }} müşteri · kartlara tıklayarak devam eden işleri görüntüleyebilirsiniz
        </p>
      </div>
    </div>

    <div class="row musteri-kart-grid">
      <div
        v-for="musteri in paginatedmusteriler"
        :key="musteri.id"
        class="col-12 col-sm-6 col-md-4 col-lg-3 mb-4"
      >
        <div
          class="card h-100 musteri-ozet-kart shadow-sm border-0"
          @click="kartTikla(musteri)"
        >
          <div class="card-header bg-transparent border-bottom py-3">
            <div class="d-flex align-items-start justify-content-between gap-2">
              <h5 class="mb-0 fw-semibold text-truncate" :title="musteri.unvan">
                {{ musteri.unvan }}
              </h5>
              <span
                v-if="musteri.devamedenisler && musteri.devamedenisler.length"
                class="badge bg-primary flex-shrink-0"
              >
                {{ musteri.devamedenisler.length }}
              </span>
            </div>
          </div>

          <div class="card-body pt-2">
            <div v-if="!musteri.devamedenisler || !musteri.devamedenisler.length" class="text-muted small py-2">
              Devam eden iş yok
            </div>
            <ul v-else class="list-unstyled mb-0 musteri-is-onizleme">
              <li
                v-for="is in onizlemeIsleri(musteri)"
                :key="is.id"
                class="musteri-is-satir mb-2"
              >
                <div class="fw-medium text-truncate" :title="is.ad">{{ is.ad }}</div>
                <div class="text-muted small text-truncate-2" :title="is.aciklama">
                  {{ is.aciklama || '—' }}
                </div>
              </li>
              <li
                v-if="musteri.devamedenisler.length > onizlemeLimit"
                class="text-muted small"
              >
                +{{ musteri.devamedenisler.length - onizlemeLimit }} iş daha
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-4" v-if="musteriler_toplamSayfa > 1">
      <div class="col-12 text-center">
        <nav>
          <ul class="pagination justify-content-center mb-0">
            <li
              class="page-item"
              :class="{ active: page === musteriler.seciliSayfa }"
              v-for="page in pages"
              :key="page"
            >
              <a class="page-link" href="#" @click.prevent="musterilerSayfaDegistir(page)">{{ page }}</a>
            </li>
          </ul>
        </nav>
      </div>
    </div>

    <div class="modal fade modal-close-out show" style="display: block;" v-if="seciliMusteri">
      <div class="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ seciliMusteri.unvan }}</h5>
            <button type="button" class="btn-close" @click="modalKapat" aria-label="Kapat"></button>
          </div>
          <div class="modal-body">
            <p class="small text-muted mb-3">Devam eden işler</p>
            <div v-if="!seciliMusteri.devamedenisler || !seciliMusteri.devamedenisler.length" class="text-muted small py-2">
              Bu müşteriye ait devam eden iş bulunmuyor.
            </div>
            <ul v-else class="list-unstyled mb-0 musteri-is-detay">
              <li
                v-for="is in seciliMusteri.devamedenisler"
                :key="is.id"
                class="musteri-is-satir mb-3 pb-3 border-bottom"
              >
                <div class="fw-semibold">{{ is.ad }}</div>
                <div class="text-muted small mt-1">{{ is.aciklama || '—' }}</div>
                <router-link
                  v-if="yetki_kontrol('is_goster')"
                  :to="'/isler/' + is.id"
                  class="btn btn-link btn-sm px-0 mt-1"
                  @click="modalKapat"
                >
                  İş detayı →
                </router-link>
              </li>
            </ul>
          </div>
          <div class="modal-footer flex-wrap gap-2">
            <button
              v-if="yetki_kontrol('is_ekle')"
              type="button"
              class="btn btn-primary btn-sm"
              @click="isEkleModal"
            >
              İş Ekle
            </button>
            <router-link
              v-if="yetki_kontrol('musteri_goster')"
              :to="'/musteriler/' + seciliMusteri.id"
              class="btn btn-outline-secondary btn-sm"
              @click="modalKapat"
            >
              Müşteri Detay
            </router-link>
            <button
              v-if="yetki_kontrol('musteri_duzenle')"
              type="button"
              class="btn btn-outline-primary btn-sm"
              @click="duzenleModal"
            >
              Düzenle
            </button>
            <button
              v-if="yetki_kontrol('musteri_sil')"
              type="button"
              class="btn btn-outline-danger btn-sm"
              @click="sil(seciliMusteri.id)"
            >
              Sil
            </button>
            <button type="button" class="btn btn-light btn-sm ms-auto" @click="modalKapat">
              Kapat
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axiosCustom from "@/services/axiosCustom";
import { yetkiKontrol } from '@/services/yetkiKontrol';

export default {
  props: {
    musteriler: {
      type: Object,
      required: true,
    },
    duzenle: Function,
    formKaydetSonrasi: Function,
    tur: String,
  },
  emits: ['update:musteriler', 'isEkle'],
  data() {
    return {
      seciliMusteri: null,
      onizlemeLimit: 3,
    };
  },
  computed: {
    karsilamaMesaji() {
      const saat = new Date().getHours();
      if (saat < 12) return 'Günaydın';
      if (saat < 18) return 'İyi günler';
      return 'İyi akşamlar';
    },
    filteredmusteriler() {
      const kelime = (this.musteriler.arananKelime || '').toLowerCase();
      if (!kelime) {
        return this.musteriler.tumu || [];
      }
      return (this.musteriler.tumu || []).filter((musteri) => {
        const alanlar = [
          musteri.unvan,
          musteri.telefon,
          musteri.email,
          musteri.adres,
          musteri.kullaniciadi,
        ];
        return alanlar.some((a) => (a || '').toLowerCase().includes(kelime));
      });
    },
    paginatedmusteriler() {
      const start = (this.musteriler.seciliSayfa - 1) * this.musteriler.sayfadaKayit;
      const end = start + this.musteriler.sayfadaKayit;
      return this.filteredmusteriler.slice(start, end);
    },
    musteriler_toplamSayfa() {
      const totalFilteredUsers = this.filteredmusteriler.length;
      const maxPage = Math.max(Math.ceil(totalFilteredUsers / this.musteriler.sayfadaKayit), 1);
      if (this.musteriler.seciliSayfa > maxPage) {
        this.musterilerSayfaDegistir(maxPage);
      }
      return maxPage;
    },
    pages() {
      const totalPageCount = this.musteriler_toplamSayfa;
      const maxVisiblePages = 5;
      const currentPage = this.musteriler.seciliSayfa;

      if (totalPageCount <= maxVisiblePages) {
        return Array.from({ length: totalPageCount }, (_, index) => index + 1);
      }

      const pagesBefore = Math.max(currentPage - Math.floor(maxVisiblePages / 2), 1);
      const pagesAfter = Math.min(pagesBefore + maxVisiblePages - 1, totalPageCount);

      return Array.from({ length: pagesAfter - pagesBefore + 1 }, (_, index) => pagesBefore + index);
    },
  },
  methods: {
    yetki_kontrol(yetki) {
      return yetkiKontrol(yetki);
    },
    onizlemeIsleri(musteri) {
      const liste = musteri.devamedenisler || [];
      return liste.slice(0, this.onizlemeLimit);
    },
    kartTikla(musteri) {
      this.seciliMusteri = musteri;
    },
    modalKapat() {
      this.seciliMusteri = null;
    },
    duzenleModal() {
      const musteri = this.seciliMusteri;
      this.modalKapat();
      if (musteri && this.duzenle) {
        this.duzenle(musteri);
      }
    },
    isEkleModal() {
      const musteri = this.seciliMusteri;
      this.modalKapat();
      if (musteri) {
        this.$emit('isEkle', musteri);
      }
    },
    async sil(musteriId) {
      const result = await this.$swal({
        title: 'Emin misiniz?',
        text: 'Bu işlemi geri alamayacaksınız!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Evet, sil!',
        cancelButtonText: 'İptal',
      });

      if (result.isConfirmed) {
        try {
          await axiosCustom.post('musteriler/sil/' + musteriId);
          this.$toast.success('Müşteri silindi');
          this.modalKapat();
          this.formKaydetSonrasi();
        } catch (error) {
          console.error('Silme hatası: ', error);
          this.$toast.error('Silme hatası');
        }
      }
    },
    musterilerSayfaDegistir(page) {
      this.modalKapat();
      this.$emit('update:musteriler', {
        ...this.musteriler,
        seciliSayfa: page,
      });
    },
  },
};
</script>

<style scoped>
.musteriler-karsilama {
  background: linear-gradient(135deg, rgba(207, 38, 55, 0.06) 0%, rgba(255, 255, 255, 1) 60%);
}

.musteri-ozet-kart {
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.musteri-ozet-kart:hover {
  transform: translateY(-2px);
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.08) !important;
}

.musteri-is-satir:last-child {
  margin-bottom: 0 !important;
}

.text-truncate-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
</style>
